/** Custom statuses where days-on-market stops at off_market_date — keep aligned with BE. */
export const CUSTOM_STATUSES_REQUIRING_OFF_MARKET_DATE = ['under_contract', 'sold'];

export function requiresOffMarketDate(status) {
  if (!status) return false;
  return CUSTOM_STATUSES_REQUIRING_OFF_MARKET_DATE.includes(String(status).trim());
}

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Format ISO/date value for `<input type="date">` (YYYY-MM-DD). */
export function formatDateForInput(value) {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

/** Parse YYYY-MM-DD from date input to ISO date string for API. */
export function parseDateInput(value) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return null;
  const d = new Date(`${trimmed}T00:00:00.000Z`);
  if (Number.isNaN(d.getTime())) return undefined;
  return d.toISOString();
}

/**
 * Client-side preview of days on market — mirrors BE computeDaysOnMarket for manual fields.
 */
export function computePreviewDaysOnMarket({
  onMarketDate,
  offMarketDate,
  customPropertyStatus,
  now = new Date(),
}) {
  const startRaw = onMarketDate ? new Date(onMarketDate) : null;
  if (!startRaw || Number.isNaN(startRaw.getTime())) return null;
  if (!customPropertyStatus && !onMarketDate) return null;

  let end = now;
  if (requiresOffMarketDate(customPropertyStatus)) {
    if (offMarketDate) {
      const off = new Date(offMarketDate);
      end = Number.isNaN(off.getTime()) ? now : off;
    }
  }

  const diff = end.getTime() - startRaw.getTime();
  if (diff < 0) return 0;
  return Math.floor(diff / MS_PER_DAY);
}
